<app-base-modal
  [title]="'Упаковка'"
  [showStateToggle]="isValid"
>
  <button
    mat-button
    color="primary"
    class="product-package-import-btn"
    (click)="handelImportPackages()"
  >
    Импорт упаковок
  </button>
  <div class="wrapper">
    @if (isLoading) {
      <app-loader/>
    }
    <mat-accordion [multi]="true">
      @for (productPackage of productPackagesData; track $index) {
        <mat-expansion-panel [expanded]="productPackage.id === 0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <app-product-package-accordion-title
                class="product-package-accordion-title"
                [productPackage]="productPackage"
                [isEditModeActive]="isEditModeActive"
                (deleteRecord)="handleDelete($event, $index)"
              />
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-product-package-form
            [parentId]="productPackageDialogData.parentId"
            [productPackageFormGroup]="productPackageFormGroups[$index]"
            [productPackageData]="productPackage"
            [isEditModeActive]="isEditModeActive"
            [noFirstData]="noFirstData"
            (updateProductPackageData)="updateProductPackageData($event, $index)"
            (deleteProductPackage)="deleteProductPackage($index)"
          />
          @if (productPackage.id) {
            <div
              app-product-package-files
              [productPackageId]="productPackage.id"
              [isEditModeActive]="isEditModeActive"
              class="product-package-files"
            ></div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      type="button"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
    <button
      mat-button
      color="primary"
      type="button"
      [disabled]="!isValid"
      (click)="handleAddNew()"
    >
      Добавить новую
    </button>
  </div>
</app-base-modal>
